
import classNames from "classnames";
import IconCollection from "../IconCollection/IconCollection";
import css from "./MerchantBanner.module.css"
import { FormattedMessage } from "react-intl";
import { findDbCategoryByRef, getCategoryDisplayId } from "../../util/data";

const MerchantBanner = (props) => {
    const {
        businessTitle,
        categoryLevel1,
        categoryLevel2,
        categories = [],
        intl,
    } = props
    const arabicLanguage = typeof window !== 'undefined' && localStorage.getItem("language") === "Arabic";
    const displayCategoryLevel1 = getCategoryDisplayId(categoryLevel1, categories);
    const displayCategoryLevel2 = getCategoryDisplayId(categoryLevel2, categories);
    // Resolved by slug (with a uuid fallback) — see findDbCategoryByRef. These
    // are flat /api/categories rows, so the display name is nameEn.
    const cat1 = findDbCategoryByRef(categories, categoryLevel1);
    const cat2 = findDbCategoryByRef(categories, categoryLevel2);
    const cat1Label = cat1?.nameEn || cat1?.label;
    const cat2Label = cat2?.nameEn || cat2?.label;
    return (
        <div className={classNames(css.bannerContainer, arabicLanguage && css.arabicDirection)}>
            <h2 className={css.vendorTitle}>{businessTitle}</h2>
           <div className={css.starContent}>
           <p className={css.subTitle}>
                {displayCategoryLevel1 && intl.formatMessage({ id: `category.${displayCategoryLevel1}`, defaultMessage: cat1Label || categoryLevel1 })}
                {displayCategoryLevel2 &&
                    ` / ${intl.formatMessage({ id: `category.${displayCategoryLevel2}`, defaultMessage: cat2Label || categoryLevel2 })}`
                }
            </p>
           </div>

            <div className={css.poweredByBanner}>
                <div className={css.bannerContent}>
                <p className={css.poweredText}><FormattedMessage id="ViewBusiness.poweredBy"/></p>
                <IconCollection name="poweredByIcon"/>
                </div>
            <span className={css.backIcon}><IconCollection name="poweredBy"/></span>
            </div>
        </div>
    )
}

export default MerchantBanner;